import { useEffect, useState } from 'react';

const SECTIONS = [
  { id: 'manifiesto', label: 'Manifiesto' },
  { id: 'oficios',    label: 'Oficios'    },
  { id: 'contacto',   label: 'Contacto'   },
];

export default function Navbar() {
  const [active, setActive] = useState('manifiesto');

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); }),
      { rootMargin: '-40% 0px -55% 0px' },
    );
    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <nav
      className="fixed top-0 left-1/2 -translate-x-1/2 z-50
                 flex gap-7 px-7 py-3.5 bg-carbon text-papel
                 rounded-b-3xl font-mono text-[11px] tracking-[0.18em] uppercase"
    >
      {SECTIONS.map(({ id, label }) => (
        <a
          key={id}
          href={`#${id}`}
          className={
            'relative transition-colors hover:text-papel ' +
            (active === id ? 'text-papel' : 'text-papel/60')
          }
        >
          {label}
          {active === id && (
            <span className="absolute -right-2.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-senal shadow-[0_0_8px_rgba(200,255,62,0.65)]" />
          )}
        </a>
      ))}
    </nav>
  );
}
